// extracted by mini-css-extract-plugin
var _1 = "ndxnsLmyPCn7uLkjVclG";
export { _1 as "language" }
